import Axios from 'axios';
import ApiConfig from '../config/ApiConfig';

export const createLab = async (parentId, labData, type = 'section') => {
    const token = localStorage.getItem('token');
    const response = await Axios.post(
        `${ApiConfig.labs.create}/${parentId}?type=${type}`,
        labData,
        {
            headers: {
                Accept: '*',
                Authorization: `Bearer ${token}`
            }
        }
    );
    return response.data;
};

export const editLabApi = async (labId, labData) => {
    const token = localStorage.getItem('token');
    const response = await Axios.put(
        `${ApiConfig.labs.edit}/${labId}`,
        labData,
        {
            headers: {
                Accept: '*',
                Authorization: `Bearer ${token}`
            }
        }
    );
    return response.data;
};

export const deleteLab = async (labId, parentId, type = 'section') => {
    const token = localStorage.getItem('token');
    const response = await Axios.delete(
        `${ApiConfig.labs.delete}/${labId}/${parentId}?type=${type}`,
        {
            headers: {
                Accept: '*',
                Authorization: `Bearer ${token}`
            }
        }
    );
    return response.data;
};

export const getIndividualLab = async (labId) => {
    const token = localStorage.getItem('token');
    const response = await Axios.get(
        `${ApiConfig.labs.getIndividual}/${labId}`,
        {
            headers: {
                Accept: '*',
                Authorization: `Bearer ${token}`
            }
        }
    );
    return response.data;
};
